import axios from '../api/BaseURL';
import authHeader from './auth-header';

class popTypeAPI {
  // pop type create
  createPopType(data) {
    return axios.post('/pop/add', data, { headers: authHeader() });
  }

  // list
  getList() {
    return axios.get('/pop/list', { headers: authHeader() });
  }

  // pop type delete
  deletePopType(id) {
    return axios.delete('/pop/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    });
  }

  // change status
  changeStatus(id) {
    return axios.put(
      '/pop/changeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    );
  }

  // pop type update
  updatePopType(data) {
    return axios.put('/pop/update', data, {
      headers: authHeader(),
    });
  }

  // district list
  districtList() {
    return axios.get('/location/districtList', { headers: authHeader() });
  }

  // details district by ID
  districtDetails(id) {
    return axios.get('/location/getDistrictById/' + id, {
      headers: authHeader(),
    });
  }
}
export default new popTypeAPI();
